/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type note_FullPlanNote$ref = any;
export type note_removePlanNote_MutationVariables = {|
  noteId: any
|};
export type note_removePlanNote_MutationResponse = {|
  +noteMutation: ?{|
    +removeNote: ?{|
      +id: string,
      +notes: $ReadOnlyArray<?{|
        +$fragmentRefs: note_FullPlanNote$ref
      |}>,
    |}
  |}
|};
export type note_removePlanNote_Mutation = {|
  variables: note_removePlanNote_MutationVariables,
  response: note_removePlanNote_MutationResponse,
|};
*/


/*
mutation note_removePlanNote_Mutation(
  $noteId: UUID!
) {
  noteMutation {
    removeNote(noteId: $noteId) {
      id
      notes {
        ...note_FullPlanNote
        id
      }
    }
  }
}

fragment note_FullPlanNote on PlanNote {
  id
  text
  auditMeta {
    created
    createdBy {
      userName
      firstName
      lastName
      id
    }
    updated
    updatedBy {
      userName
      firstName
      lastName
      id
    }
  }
  pinned
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "noteId",
    "variableName": "noteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "lastName",
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "note_removePlanNote_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteMutation",
        "kind": "LinkedField",
        "name": "noteMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "removeNote",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlanNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "note_FullPlanNote"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "note_removePlanNote_Mutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteMutation",
        "kind": "LinkedField",
        "name": "noteMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Plan",
            "kind": "LinkedField",
            "name": "removeNote",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlanNote",
                "kind": "LinkedField",
                "name": "notes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "text",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuditMeta",
                    "kind": "LinkedField",
                    "name": "auditMeta",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuditUser",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "updated",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AuditUser",
                        "kind": "LinkedField",
                        "name": "updatedBy",
                        "plural": false,
                        "selections": (v3/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pinned",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3cbfc5e21e8a9c45a182cce5fccd44aa",
    "id": null,
    "metadata": {},
    "name": "note_removePlanNote_Mutation",
    "operationKind": "mutation",
    "text": "mutation note_removePlanNote_Mutation(\n  $noteId: UUID!\n) {\n  noteMutation {\n    removeNote(noteId: $noteId) {\n      id\n      notes {\n        ...note_FullPlanNote\n        id\n      }\n    }\n  }\n}\n\nfragment note_FullPlanNote on PlanNote {\n  id\n  text\n  auditMeta {\n    created\n    createdBy {\n      userName\n      firstName\n      lastName\n      id\n    }\n    updated\n    updatedBy {\n      userName\n      firstName\n      lastName\n      id\n    }\n  }\n  pinned\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a30bf4da90c259235bc841d7e8186448';

module.exports = node;
